export const access_token = process.env.REACT_APP_ACCESS_TOKEN;
export const refresh_token = process.env.REACT_APP_REFRESH_TOKEN;
export const user_name = process.env.REACT_APP_USER_NAME;
export const wholesaler_retailer = process.env.REACT_APP_WHOLESALER_RETAILER;
export const api_urls_http = process.env.REACT_APP_API_URLS_HTTP;
export const api_urls_https = process.env.REACT_APP_API_URLS_HTTPS;
export const web_name = process.env.REACT_APP_WEB_NAME;
export const support_mail = process.env.REACT_APP_SUPPORT_MAIL;
export const support_number = process.env.REACT_APP_SUPPORT_NUMBER;
export const web_domain = process.env.REACT_APP_WEB_DOMAIN;
export const current_year = new Date().getFullYear();